import { API} from "api";
export const getAdminRolesAPI = () => {
    return API.get('api/security/administrator/getall/true').then((res) => res);
}